import React from 'react'
import PropTypes from 'prop-types'
import Headline from '#components/a/Headline'
import Text from '#components/a/Text'

function QuestionDescription(props) {
  const {question} = props

  return (
    <div className="questiondescription">
      <Headline text={`Frage ${question.order}`} modifier="category" importance={2} />
      {question.text && <Text text={question.text} />}
      {question.additionalText && <Text text={question.additionalText} />}
      {question.imageUrl && <img alt={question.imgaeUrl} src={`/api/files/staticfiles/${question.imageUrl}`} />}
    </div>
  )
}

QuestionDescription.propTypes = {
  question: PropTypes.object.isRequired,
}

export default QuestionDescription
